import { useTranslation } from 'react-i18next';
import { Route, Routes } from 'react-router-dom';
import { WithTabTitle } from '../../../../common/widgets/withTabTitle';
import { resources } from '../../resources/resources';
import MerchantsLayout from '../../layout/layouts/MerchantsLayout';
import { NotificationList } from '../../Pages/Notifications';
import { NotificationDetails } from '../../Pages/Notifications/NotificationDetails';

export const NotificationsRoutes = () => {
  const { t: translate } = useTranslation();
  return (
    <Routes>
      <Route
        path="/"
        element={
          <WithTabTitle title={translate(resources.menu.notifications)}>
            <MerchantsLayout>
              <NotificationList />
            </MerchantsLayout>
          </WithTabTitle>
        }
      />
      <Route
        path="/:notificationId"
        element={
          <WithTabTitle title={translate(resources.menu.notifications)}>
            <MerchantsLayout>
              <NotificationDetails />
            </MerchantsLayout>
          </WithTabTitle>
        }
      />
    </Routes>
  );
};
